module.exports = __webpack_public_path__ + "img/shisanz0547.975ea152.png";